import { motion } from "framer-motion";
import { Leaf } from "lucide-react";

export default function SceneLogo() {
  return (
    <section
      id="kostra-reveal"
      data-testid="scene-logo"
      className="relative min-h-[100vh] w-full overflow-hidden bg-beige"
    >
      {/* Organic backgrounds */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] rounded-full bg-[var(--k-olive-soft)] opacity-40 blur-[120px]" />
        <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] rounded-full bg-[var(--k-sand)] opacity-60 blur-[100px]" />
      </div>

      {/* Floating leaves */}
      <div className="absolute inset-0 pointer-events-none">
        {Array.from({ length: 10 }).map((_, i) => (
          <motion.div
            key={i}
            className="absolute leaf-float"
            style={{
              left: `${(i * 11 + 5) % 95}%`,
              top: `${(i * 23 + 10) % 80}%`,
              animationDelay: `${i * 0.7}s`,
            }}
          >
            <Leaf
              className="text-[var(--k-olive)]"
              style={{
                width: `${12 + (i % 3) * 6}px`,
                height: `${12 + (i % 3) * 6}px`,
                opacity: 0.25 + (i % 4) * 0.1,
                transform: `rotate(${i * 47}deg)`,
              }}
              strokeWidth={1.2}
            />
          </motion.div>
        ))}
      </div>

      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center text-center px-6 py-32">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1.4 }}
          className="font-mono-label text-[var(--k-gold)] mb-8 flex items-center gap-3"
        >
          <Leaf className="w-3 h-3" strokeWidth={1.5} />
          Introducing
          <Leaf className="w-3 h-3" strokeWidth={1.5} />
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, scale: 1.3, filter: "blur(20px)" }}
          whileInView={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 1.7, ease: [0.16, 1, 0.3, 1] }}
          className="font-serif-display text-[6rem] md:text-[12rem] lg:text-[16rem] leading-[0.85] tracking-tight green-gradient-text"
          data-testid="kostra-logo-title"
        >
          KOSTRA
        </motion.h2>

        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, delay: 0.6 }}
          className="hairline-green w-64 my-8"
        />

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.9 }}
          className="font-serif-display italic text-2xl md:text-4xl text-[var(--k-text-2)] max-w-3xl"
        >
          Building India's Next Generation <br />
          Cloud Kitchen Network.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 1.3 }}
          className="mt-14 grid grid-cols-3 gap-6 md:gap-16 font-mono-label text-[var(--k-muted)]"
        >
          <span>Plug & Play</span>
          <span>FOCO Model</span>
          <span>Brand Incubation</span>
        </motion.div>
      </div>
    </section>
  );
}
